import moment from "moment";
import { DetailsRow, StringObject } from "./types";
import React from "react";

export const mapByRefValue = (
  objectWithRef_Values: StringObject,
  refDetails: DetailsRow[],
) => {
  const _refDetails = refDetails.map((item) => {
    if (!item.refValue) return item;
    return {
      ...item,
      value: objectWithRef_Values[item?.refValue],
    };
  });
  return _refDetails;
};

export const defaultRenderObject = (object: any) => {
  return JSON.stringify(object);
};

export const defaultRenderArray = (array: any[]) => {
  if (array.length > 0 && React.isValidElement(array[0])) {
    return <>{array}</>;
  }
  return array.join(", ");
};

export const defaultRenderDates = (date: Date) => {
  return moment(date).format("DD/MM/YYYY");
};
